/**
 * Public Feature Request submission page.
 *
 * Wraps the shared FeatureRequestSubmitPage wizard in:
 *   - the public FrApiProvider (anonymous endpoints + per-draft X-FR-Token)
 *   - a standalone public layout (no admin sidebar) with brand chrome
 *
 * Routed at `/submit-feature-request` (outside the auth-guarded layout).
 */
import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { FrApiProvider } from "@/lib/frApi";
import FeatureRequestSubmitPage from "@/pages/FeatureRequestSubmitPage";


export default function PublicFeatureRequestSubmitPage() {
    return (
        <FrApiProvider mode="public">
            <div className="min-h-screen bg-[#050505] text-white">
                <PublicHeader />
                <main className="px-4 sm:px-8 py-10" data-testid="public-feature-request-page">
                    <FeatureRequestSubmitPage />
                </main>
                <PublicFooter />
            </div>
        </FrApiProvider>
    );
}


function PublicHeader() {
    return (
        <header className="border-b border-white/10 bg-[#0a0a0a]/80 backdrop-blur">
            <div className="max-w-5xl mx-auto px-4 sm:px-8 py-5 flex items-center justify-between">
                <Link to="/submit-feature-request"
                      className="flex items-center gap-3 text-sm font-medium hover:opacity-80 transition"
                      data-testid="public-header-brand">
                    <div className="grid grid-cols-1 gap-1">
                        <div className="flex gap-0.5">
                            <span className="w-1.5 h-1.5 rounded-sm bg-[#7C3AED]" />
                            <span className="w-1.5 h-1.5 rounded-sm bg-[#7C3AED]" />
                        </div>
                        <div className="flex gap-0.5">
                            <span className="w-1.5 h-1.5 rounded-sm bg-[#7C3AED]" />
                            <span className="w-1.5 h-1.5 rounded-sm bg-[#7C3AED]" />
                        </div>
                    </div>
                    <div>
                        <div className="font-display text-base font-semibold tracking-tight">
                            <span className="text-white">SiteCentric</span>
                            <span className="text-[#7C3AED]"> AI</span>
                        </div>
                        <div className="text-[10px] uppercase tracking-wider text-white/40">
                            Suggest a Feature
                        </div>
                    </div>
                </Link>
                <div className="hidden sm:flex items-center gap-2 text-[11px] text-white/45">
                    <Sparkles className="w-3.5 h-3.5 text-violet-300" strokeWidth={1.5} />
                    Powered by Claude Sonnet 5.5
                </div>
            </div>
        </header>
    );
}


function PublicFooter() {
    return (
        <footer className="border-t border-white/10 mt-8 py-6 text-center text-[11px] text-white/35">
            Your submission is reviewed by the SiteCentric product team.
            We&apos;ll reach out at the email you provide if we need anything else.
        </footer>
    );
}
